import { lazy, Suspense } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * React.lazy assumes that you're using a default export. At the time of writing this, there were a couple
 * activity cards which were not exporting their component as a default export. This function wraps the loader
 * to provide a default attribute on the module.
 */
function loaderWithDefaultFallback(loader) {
  return () => loader().then(mod => {
    if (!mod.default) {
      return {
        default: mod
      };
    }
    return mod;
  });
}
function DefaultLoadingSpinner() {
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered",
    grow: true
  });
}
export function makeAsyncCardComponent({
  loader,
  LoadingComponent = DefaultLoadingSpinner,
  disableLoadingComponent
}) {
  const AsyncComponent = /*#__PURE__*/lazy(loaderWithDefaultFallback(loader));
  return function AsyncCardComponentLoader(props) {
    return /*#__PURE__*/_jsx(Suspense, {
      fallback: !disableLoadingComponent && LoadingComponent ? /*#__PURE__*/_jsx(LoadingComponent, Object.assign({}, props)) : null,
      children: /*#__PURE__*/_jsx(AsyncComponent, Object.assign({}, props))
    });
  };
}